module.exports = __webpack_public_path__ + "img/metrics-icon.efa41bb8.svg";